<app-base-app
  [state]="state"
  [static]="static"
  [itemModel]="ItemModel.WebViewer"
  [interactionBarConfig]="{
    showScreenshotButton:
      (hyperbeamState$ | async) === HyperbeamState.NoError &&
      (isFullscreenAppInCall$ | async) === false,
    showAvailabilityButton: isWebViewerEnabledForCurrentSpace$ | async,
    showLockButton: isWebViewerEnabledForCurrentSpace$ | async,
    showPrivacyButton: isWebViewerEnabledForCurrentSpace$ | async,
    showRefreshButton: isWebViewerEnabledForCurrentSpace$ | async,
    showDuplicateButton: false,
    showFullScreenButton: true,
    showFileManagerButton:
      (isPortalInstance$ | async) &&
      (hyperbeamState$ | async) === HyperbeamState.NoError &&
      (hasPortalFiles$ | async) &&
      (isFileManagerEnabled$ | async),
    hasNewFiles: hasNewFiles$ | async
  }"
  (refreshButtonClicked)="reloadWebViewer(false, true)"
  (interactionsLockChanged)="onInteractionsLockChanges($event)"
  (privacyChanged)="onPrivacyChanged($event)"
  (deleteItem)="onDeleteItem()"
  (screenshotTaken)="takeScreenshot()"
  (availabilityChanged)="onAvailabilityChanged($event)"
  (fileManagerButtonClicked)="openFileManager()"
  [shouldRunAppOnMobile]="shouldRunAppOnMobile"
  [selected]="selected$ | async"
  [shouldDisableInteractions]="shouldDisableInteractions$ | async"
  [showLoadingIndicator]="showLoadingIndicator$ | async"
  [appIcon]="appIcon$ | async"
  [available]="state.available"
  #baseAppComponent
>
  <div #webViewerContainer [style.width]="'100%'" [style.height]="'100%'">
    <ng-container *ngIf="hyperbeamState$ | async as hyperbeamState">
      <app-web-viewer-availability
        (switchAvailabilityHandler)="baseAppComponent?.handleSwitchAvailability()"
        (availabilityNotificationStatusChanged)="OnAvailabilityNotificationStatusChanged($event)"
        (webViewerAvailable)="webViewerAvailable$.next($event)"
        [ownerId]="state.ownerId"
        [appUid]="state.uid"
        [hasAvailabilityNotification]="state.hasAvailabilityNotification"
        [available]="state.available"
      >
      </app-web-viewer-availability>

      <app-web-viewer-performance-pause-modal
        *ngIf="
          (shouldPauseWebViewerForPerformance$ | async) &&
          (hyperbeamState === HyperbeamState.NotInitialized ||
            hyperbeamState === HyperbeamState.NoError)
        "
        [modalType]="
          hyperbeamState === HyperbeamState.NoError
            ? WebViewerPausedModalType.RESUME
            : WebViewerPausedModalType.START
        "
        (startOrResumeWebViewer)="setItemAsPerformanceActiveWebViewer()"
      >
      </app-web-viewer-performance-pause-modal>

      <ng-container *ngIf="isWebViewerEnabledForCurrentSpace$ | async; else upgradeMessage">
        <div
          [hidden]="static || hyperbeamState !== HyperbeamState.NoError"
          #webViewerEmbed
          class="web-viewer"
        ></div>

        <div
          *ngIf="
            hyperbeamState === HyperbeamState.SessionTerminated ||
            hyperbeamState === HyperbeamState.PotentiallyTerminated
          "
          [hidden]="isReloading$ | async"
          class="web-viewer-suspended"
        >
          <div>
            {{
              (hyperbeamState === HyperbeamState.PotentiallyTerminated
                ? 'Your browsing session could not be loaded at this time.'
                : 'Your browsing session was suspended due to inactivity.'
              ) | translate
            }}
          </div>
          <div *ngIf="webViewerAvailable$ | async">
            <button
              color="primary"
              class="w-100 mt-2"
              mat-flat-button
              (click)="reloadWebViewer(hyperbeamState !== HyperbeamState.PotentiallyTerminated)"
            >
              <mat-icon>refresh</mat-icon>
              <span>{{ 'Reload session' | translate }}</span>
            </button>
          </div>
        </div>

        <div
          [hidden]="(isReloading$ | async) || hyperbeamState !== HyperbeamState.TimedOut"
          class="web-viewer-suspended"
        >
          <div *ngIf="userOffline$ | async" [style]="{ 'text-align': 'center' }">
            {{ 'It appears your network connection might be unstable.' | translate }}
            <br />
            {{ 'Please wait a few moments or try another network.' | translate }}
          </div>
          <div *ngIf="(userOffline$ | async) === false" [style]="{ 'text-align': 'center' }">
            {{ 'We could not connect to our servers.' | translate }}
            <br />
            {{ 'This may be due to your network connection or firewall settings.' | translate }}
          </div>
          <div class="offline-buttons">
            <button
              *ngIf="(userOffline$ | async) === false"
              class="w-100 mt-2"
              color="primary"
              mat-flat-button
              (click)="openTroubleShootLink()"
            >
              <mat-icon [style.width.px]="48">open_in_new</mat-icon>
              <span>{{ 'Troubleshoot' | translate }}</span>
            </button>

            <button
              color="primary"
              class="w-100 mt-2"
              [ngClass]="{ 'secondary-button': (userOffline$ | async) === false }"
              mat-flat-button
              (click)="reloadWebViewer(false, true)"
            >
              <mat-icon>refresh</mat-icon>
              <span>{{ 'Refresh' | translate }}</span>
            </button>
          </div>
        </div>

        <div
          *ngIf="
            hyperbeamState === HyperbeamState.InvalidParams ||
            hyperbeamState === HyperbeamState.UnknownError
          "
          [hidden]="isReloading$ | async"
          class="web-viewer-suspended"
        >
          <div>
            {{ 'Your browsing session could not be loaded at this time.' | translate }}
          </div>
          <button
            color="primary"
            class="mt-2"
            mat-flat-button
            (click)="reloadWebViewer(false, true)"
          >
            <mat-icon>refresh</mat-icon>
            <span>{{ 'Refresh' | translate }}</span>
          </button>
        </div>
      </ng-container>
    </ng-container>
  </div>
</app-base-app>

<ng-template #upgradeMessage>
  <div class="upgrade-container">
    {{ disableReasonMessage$ | async }}
  </div>
</ng-template>
